import { Users, GlassWater, Palmtree, Sparkles } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal, SectionHead } from "./Reveal";

const ICONS = [Users, GlassWater, Palmtree, Sparkles];
const STYLES = [
  "lg:col-span-7 bg-mango text-paper",
  "lg:col-span-5 bg-paper text-jungle border border-jungle/15",
  "lg:col-span-5 bg-flamingo text-deep",
  "lg:col-span-7 bg-jungle text-paper",
];

export const Vision = () => {
  const { t } = useLang();
  return (
    <section id="vision" data-testid="vision-section" className="bg-tropical-light py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHead id="vision" eyebrow={t.vision.eyebrow} title={t.vision.title} />
        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-5">
          {t.vision.items.map((v, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.08} className={STYLES[i]  + " rounded-[2rem]"}>
                <article data-testid={`vision-card-${i}`} className="group h-full min-h-[240px] p-8 sm:p-10 flex flex-col justify-between transition-transform duration-500 hover:-translate-y-1">
                  <div className="flex items-start justify-between">
                    <Icon size={30} strokeWidth={1.5} className="transition-transform duration-500 group-hover:rotate-12" />
                    <span className="font-mono-ed text-sm opacity-70">0{i + 1}</span>
                  </div>
                  <div className="mt-10">
                    <h3 className="font-display text-3xl sm:text-4xl leading-tight">{v.t}</h3>
                    <p className="mt-3 text-base leading-relaxed opacity-85 max-w-md">{v.d}</p>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
